const sir = {
  sirWidgetloaderUrl: 'https://widgets.sir.sportradar.com/sportradar/widgetloader',
};

export default sir;
